










































import Vue from 'vue';
import { mapState } from 'vuex';
import SquareEditOutlineIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import Content from '@/dex-shared/components/content/Content.vue';
import Loading from '@/dex-shared/components/Loading.vue';
import pxCard from '@/dex-shared/components/px-card.vue';
import KnowledgeShow from '@/components/knowledge/KnowledgeShow.vue';
import TreeKnowledgeShow from '@/components/knowledge/TreeKnowledgeShow.vue';

export default Vue.extend({
  components: {
    Content,
    pxCard,
    Loading,
    SquareEditOutlineIcon,
    KnowledgeShow,
    TreeKnowledgeShow,
  },

  data() {
    return {
      loaded: true,
    };
  },

  computed: {
    ...mapState({
      article: (state: any) => state.articles.article,
    }),
  },

  async created() {
    let articleId = parseInt(this.$route.params.articleId);
    this.loaded = false;
    await this.$store.dispatch('PULL_ARTICLE', articleId);
    this.loaded = true;
  },
});
